const PHRASE = "Make Your Dream Home Reality";

export default function Marquee() {
  const items = [PHRASE, "Design", "Approvals", "Build", "Handover", "Tarneit · Victoria"];
  const loop = [...items, ...items, ...items, ...items];
  const dots = ["bg-arcblue", "bg-arcgreen", "bg-arcolive", "bg-arcorange", "bg-arcpink", "bg-arcpurple"];
  return (
    <section className="bg-ink py-6 overflow-hidden border-y border-white/10" data-testid="editorial-marquee" aria-hidden="true">
      <div className="flex w-max animate-marquee">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {loop.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className={`px-6 sm:px-10 whitespace-nowrap ${i % 6 === 0 ? "font-serif italic text-2xl sm:text-4xl text-gradient" : "font-mono text-[11px] sm:text-xs tracking-[0.35em] uppercase text-cream/70"}`}>
                  {item}
                </span>
                <span className={`h-1.5 w-1.5 rounded-full ${dots[i % 6]}`} />
              </span>
            ))}
          </div>
        ))}
      </div>
    </section>
  );
}
